/*
 * QQQ - Low-code Application Framework for Engineers.
 * Copyright (C) 2021-2026.  Kingsrook, LLC
 * 651 N Broad St Ste 205 # 6917 | Middletown DE 19709 | United States
 * contact@kingsrook.com
 * https://github.com/Kingsrook/
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {QFieldMetaData} from "@temple-of-syrinx/qqq-frontend-core/lib/model/metaData/QFieldMetaData";

const MATERIAL_DASHBOARD_SUPPLEMENTAL_KEY = "materialDashboard";


/*******************************************************************************
 ** Per-field hints the backend's MaterialDashboardFieldMetaData sends for the
 ** query screen.  This is the one place that knows where they live.
 *******************************************************************************/
function materialDashboardFieldMetaData(field: QFieldMetaData): any
{
   return (field?.supplementalFieldMetaData?.get(MATERIAL_DASHBOARD_SUPPLEMENTAL_KEY));
}


/*******************************************************************************
 ** The label of the columns-panel group this field belongs under, or null for
 ** the field's table.  A grouped field also starts hidden and is skipped by the
 ** table-level toggle - see QQueryColumns and FieldListMenuContent.
 *******************************************************************************/
export function getQueryScreenColumnGroup(field: QFieldMetaData): string | null
{
   const group = materialDashboardFieldMetaData(field)?.queryScreenColumnGroup;
   return (group ? String(group) : null);
}


/*******************************************************************************
 ** The separator between entries of a list-like value (e.g. "; "), when the
 ** field wants the query screen to offer expanding the cell to one entry per
 ** line (see MultiLineCell); null when it does not.
 *******************************************************************************/
export function getQueryScreenMultiLineCellSeparator(field: QFieldMetaData): string | null
{
   const separator = materialDashboardFieldMetaData(field)?.queryScreenMultiLineCellSeparator;
   return (separator ? String(separator) : null);
}
